export enum PackagesStatus {
  DESIGN = 'DESIGN',
  LIVE = 'LIVE',
  UPDATED = 'UPDATED',
  CLOSED = 'CLOSED',
  REVIEW = 'REVIEW',
  APPROVED = 'APPROVED',
  RETIRED = 'RETIRED',
}
